import React from "react";

export default function AppleWatch({ size = 260 }) {
  const scale = 0.9;
  const stroke = "#7c3aed";
  const strapFill = "rgba(124, 58, 237, 0.10)";

  const w = size * scale;
  const h = size * 1.55 * scale;

  const bodyX = w * 0.10;
  const bodyY = h * 0.32;
  const bodyW = w * 0.80;
  const bodyH = w * 0.92;
  const corner = bodyW * 0.28;

  const strapH = bodyH * 0.12;

  const left = w * 0.25;
  const right = w * 0.75;

  const topStrapPath = `
    M ${left} ${bodyY - strapH}
    C ${left} ${bodyY - strapH * 1.6},
      ${right} ${bodyY - strapH * 1.6},
      ${right} ${bodyY - strapH}
    L ${right} ${bodyY}
    C ${right} ${bodyY + strapH * 0.25},
      ${left} ${bodyY + strapH * 0.25},
      ${left} ${bodyY}
    Z
  `;

  const bottomStrapPath = `
    M ${left} ${bodyY + bodyH}
    C ${left} ${bodyY + bodyH + strapH * 1.6},
      ${right} ${bodyY + bodyH + strapH * 1.6},
      ${right} ${bodyY + bodyH}
    L ${right} ${bodyY + bodyH - strapH * 0.25}
    C ${right} ${bodyY + bodyH - strapH * 0.25},
      ${left} ${bodyY + bodyH - strapH * 0.25},
      ${left} ${bodyY + bodyH}
    Z
  `;

  const bodyPath = `
    M ${bodyX + corner} ${bodyY}
    H ${bodyX + bodyW - corner}
    C ${bodyX + bodyW - corner/3} ${bodyY},
      ${bodyX + bodyW} ${bodyY + corner/3},
      ${bodyX + bodyW} ${bodyY + corner}
    V ${bodyY + bodyH - corner}
    C ${bodyX + bodyW} ${bodyY + bodyH - corner/3},
      ${bodyX + bodyW - corner/3} ${bodyY + bodyH},
      ${bodyX + bodyW - corner} ${bodyY + bodyH}
    H ${bodyX + corner}
    C ${bodyX + corner/3} ${bodyY + bodyH},
      ${bodyX} ${bodyY + bodyH - corner/3},
      ${bodyX} ${bodyY + bodyH - corner}
    V ${bodyY + corner}
    C ${bodyX} ${bodyY + corner/3},
      ${bodyX + corner/3} ${bodyY},
      ${bodyX + corner} ${bodyY}
    Z
  `;

  const screenInset = bodyW * 0.11;

  const screenPath = `
    M ${bodyX + screenInset + corner * 0.6} ${bodyY + screenInset}
    H ${bodyX + bodyW - screenInset - corner * 0.6}
    C ${bodyX + bodyW - screenInset - corner * 0.2} ${bodyY + screenInset},
      ${bodyX + bodyW - screenInset} ${bodyY + screenInset + corner * 0.2},
      ${bodyX + bodyW - screenInset} ${bodyY + screenInset + corner * 0.6}
    V ${bodyY + bodyH - screenInset - corner * 0.6}
    C ${bodyX + bodyW - screenInset} ${bodyY + bodyH - screenInset - corner * 0.2},
      ${bodyX + bodyW - screenInset - corner * 0.2} ${bodyY + bodyH - screenInset},
      ${bodyX + bodyW - screenInset - corner * 0.6} ${bodyY + bodyH - screenInset}
    H ${bodyX + screenInset + corner * 0.6}
    C ${bodyX + screenInset + corner * 0.2} ${bodyY + bodyH - screenInset},
      ${bodyX + screenInset} ${bodyY + bodyH - screenInset - corner * 0.2},
      ${bodyX + screenInset} ${bodyY + bodyH - screenInset - corner * 0.6}
    V ${bodyY + screenInset + corner * 0.6}
    C ${bodyX + screenInset} ${bodyY + screenInset + corner * 0.2},
      ${bodyX + screenInset + corner * 0.2} ${bodyY + screenInset},
      ${bodyX + screenInset + corner * 0.6} ${bodyY + screenInset}
    Z
  `;

  const crownX = bodyX + bodyW + w * 0.03;
  const crownY = bodyY + bodyH * 0.46;

  const animateStroke = (
    <animate
      attributeName="stroke-dashoffset"
      from="1000"
      to="0"
      dur="1.8s"
      fill="freeze"
    />
  );

  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} style={{ display: "block" , paddingBottom:"50px"}}>
      {/* top strap */}
      <path
        d={topStrapPath}
        fill={strapFill}
        stroke={stroke}
        strokeWidth={w * 0.02}
        strokeDasharray="1000"
        strokeDashoffset="1000"
      >
        {animateStroke}
      </path>

      {/* bottom strap */}
      <path
        d={bottomStrapPath}
        fill={strapFill}
        stroke={stroke}
        strokeWidth={w * 0.02}
        strokeDasharray="1000"
        strokeDashoffset="1000"
      >
        {animateStroke}
      </path>

      {/* body */}
      <path
        d={bodyPath}
        fill="white"
        stroke={stroke}
        strokeWidth={w * 0.025}
        strokeDasharray="1400"
        strokeDashoffset="1400"
      >
        {animateStroke}
      </path>

      <defs>
        <linearGradient id="screenBg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="rgba(220,230,255,0.95)" />
          <stop offset="100%" stopColor="rgba(200,215,255,0.95)" />
        </linearGradient>
      </defs>

      {/* screen */}
      <path
        d={screenPath}
        fill="url(#screenBg)"
        stroke={stroke}
        strokeWidth={w * 0.018}
        strokeDasharray="1200"
        strokeDashoffset="1200"
      >
        {animateStroke}
      </path>

      {/* crown */}
      <circle
        cx={crownX}
        cy={crownY}
        r={w * 0.045}
        stroke={stroke}
        strokeWidth={w * 0.022}
        fill="white"
        strokeDasharray="200"
        strokeDashoffset="200"
      >
        {animateStroke}
      </circle>
    </svg>
  );
}
